var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Input',_vm._b({attrs:{"value":_vm.value,"state":_vm.disabled ? 'disabled' : _vm.locked ? 'disabled2' : ''},on:{"input":_vm.input}},'Input',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }